import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import Icon from '../../../../Icon'
import Pill from '../../../../Pill'

class AttributeMultiSelectPill extends PureComponent {
  render () {
    return (
      <Pill type={this.props.isSelected ? 'blue' : undefined}
            onClick={this.props.onClick}>
        <div className={'attribute-multi-select-pills-pill-content'}>
          {this.props.isSelected &&
          <span className={'attribute-multi-select-pills-pill-icon'}>
                  <Icon type={'check'} size={'extra-small'} extraClassNames={'Icon-no-margin'}/>
                </span>}
          <span>{this.props.label}</span>
          {
            this.props.definition && (
              <span className={'attribute-multi-select-pills-pill-icon'}>
                <Icon type={'how'} tooltip={this.props.definition} size={'extra-small'} extraClassNames={'Icon-no-margin'}/>
              </span>
            )
          }
        </div>
      </Pill>
    )
  }
}

AttributeMultiSelectPill.propTypes = {
  isSelected: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  definition: PropTypes.string.isRequired
}
export default AttributeMultiSelectPill
